import { useEffect, useRef } from 'react'

let instances = 0

const LoadingAnimation = () => {
  const instance = useRef(instances)

  useEffect(() => {
    instances++
  }, [])

  const id = `LoadingAnimation${instance.current}`

  return (
    <svg
      id={`${id}1`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 480"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision">
      <style>{`
      @keyframes ${id}2_s_o {
        0%,
        4.5%,
        40%,
        to {
          stroke-opacity: 0;
        }
        39%,
        5% {
          stroke-opacity: 1;
        }
      }

      @keyframes ${id}2_s_do {
        0% {
          stroke-dashoffset: 872.24;
          animation-timing-function: cubic-bezier(.715,0,.295,1.01);
        }
        40%,
        to {
          stroke-dashoffset: 0;
        }
      }
      
      @keyframes ${id}3_s_o {
        0%,
        38.5%,
        82%,
        to {
          stroke-opacity: 0;
        }
        39.5%,
        81% {
          stroke-opacity: 1;
        }
      }
      
      @keyframes ${id}3_s_do {
        0% {
          stroke-dashoffset:0;
        }
        50% {
          stroke-dashoffset: 0;
          animation-timing-function: cubic-bezier(.715,0,.295,1.01);
        }
        90%,
        to {
          stroke-dashoffset: 872.24;
        }
      }

      #${id}2-path, #${id}3-path {
        animation-duration: 2000ms;
        animation-fill-mode: forwards;
        animation-timing-function: linear;
        animation-direction: normal;
        animation-iteration-count: infinite;
      }

      #${id}2-path {
        animation-name: ${id}2_s_o, ${id}2_s_do;
      }

      #${id}3-path {
        animation-name: ${id}3_s_o, ${id}3_s_do;
      }
    `}</style>
      <defs>
        <linearGradient
          id={`${id}2-stroke`}
          x1="-.136"
          y1="1.079"
          x2=".913"
          y2=".035"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox">
          <stop
            id={`${id}2-stroke-0`}
            offset="0%"
            stopColor="#49BEBC"
          />
          <stop
            id={`${id}2-stroke-1`}
            offset="100%"
            stopColor="#49E69B"
          />
        </linearGradient>
        <linearGradient
          id={`${id}3-stroke`}
          x1="-.136"
          y1="1.079"
          x2=".913"
          y2=".035"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox">
          <stop
            id={`${id}3-stroke-0`}
            offset="0%"
            stopColor="#49BEBC"
          />
          <stop
            id={`${id}3-stroke-1`}
            offset="100%"
            stopColor="#49E69B"
          />
        </linearGradient>
      </defs>
      <path
        id={`${id}2-path`}
        d="M304.899 292.208l-142.35 64.472-4.267 147.682 95.729-40.573v-77.21l105.271-43.15-17.79 146.492-120.49 59.699"
        transform="translate(58.081 -181.153)"
        fill="none"
        stroke={`url(#${id}2-stroke)`}
        strokeWidth="60"
        strokeOpacity="0"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeDashoffset="872.24"
        strokeDasharray="872.24"
      />
      <path
        id={`${id}3-path`}
        d="M221.002 555.938l119.61-60.515 18.67-151.993-110.74 48.45 13.87 67.096-99.863 53.644v-153.4l142.35-68.54"
        transform="translate(58.081 -181.153)"
        fill="none"
        fillOpacity="0"
        stroke={`url(#${id}3-stroke)`}
        strokeWidth="60"
        strokeOpacity="0"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeDasharray="872.24"
      />
      <path
        id={`${id}4`}
        d="M439.57 252l-69 33.64 5.76-45.53A21.25 21.25 0 00346 218.36l-179.3 87.31a21.34 21.34 0 00-11.81 16.41L125.4 553.74a21.18 21.18 0 0030.27 21.72l69.05-33.6L219 587a21.19 21.19 0 0030.31 21.68l179.31-87.31A21.21 21.21 0 00440.31 505l29.57-231.3a21.21 21.21 0 00-30.31-21.7zm-32.16 214.35a44.55 44.55 0 01-24.76 34.59L298.05 542a20.32 20.32 0 01-29-20.77l102.9-50 5.26-41.78-20.6-14.64a3.08 3.08 0 01.45-5.31l61.32-29.85zm16.45-130.54L321 385.87l-7.61 59.88A27.61 27.61 0 01298.13 467L194 517.55a13.63 13.63 0 01-19.49-13.94l16.82-134.07-21.3-15.14a3.11 3.11 0 01.45-5.34l135.84-66a17.58 17.58 0 0125.13 18.05l-.62 4.9L228 356l-14.75 117.38L279 441.43l5.26-41.79L263 384.26a3.09 3.09 0 01.5-5.3L395 315.09a20.22 20.22 0 0128.86 20.72z"
        transform="translate(22.363 -173.534)"
        fill="#222632"
        stroke="none"
        strokeWidth="1"
      />
    </svg>
  )
}

export default LoadingAnimation